import { defineAbility } from '@casl/ability'
import store from '@/store'
import { permissions } from '@/api/permissions/permissions'
import { isDev } from '@/config/urls'

export class PermissionPageManager {
  // Права на просмотр страниц (Router)
  public static pages() {
    const pageList = PermissionPageManager._pages()
    return defineAbility((can) => {
      for (const page of Object.keys(pageList)) {
        can(permissions.viewPage, page)
      }
    })
  }

  private static removeRule(name: string, rules: any): void {
    if (name in rules) {
      delete rules[name]
    }
  }

  private static addRule(name: string, rules: any): void {
    rules[name] = true
  }

  // Права на просмотр страниц (Sidebar)
  public static sidebar() {
    const pageList = PermissionPageManager._pages()
    return defineAbility((can) => {
      // Остальные страницы системы - можно
      for (const page of Object.keys(pageList)) {
        can(permissions.viewPage, page)
      }
    })
  }

  public static _pages() {
    const rules: any = {}

    PermissionPageManager.addRule('HelpRoute', rules)
    if (this.user('isAuthenticated')) {
      // Для авторизованного пользователья
      PermissionPageManager.addRule('Logout', rules)
      PermissionPageManager.addRule('EnrollRoute', rules)
      PermissionPageManager.addRule('InviteLinkRoute', rules)

      if (this.user('userRoles')?.length > 0) {
        PermissionPageManager.addRule('ProgramsRoute', rules)
        PermissionPageManager.addRule('ProgramDescriptionRoute', rules)
      }

      if (this.user('isListener')) {
        PermissionPageManager.addRule('ApplicationsRoute', rules)
        PermissionPageManager.addRule('ProfileRoute', rules)
      }

      if (this.user('isAdminProgram')) {
        PermissionPageManager.addRule('AdminApplicationsRoute', rules)
        PermissionPageManager.addRule('AdminProgramsRoute', rules)
        PermissionPageManager.addRule('AdminDocumentsRoute', rules)
        PermissionPageManager.addRule('AdminDashboardsRoute', rules)
        PermissionPageManager.addRule('UniversitiesDictRoute', rules)
        PermissionPageManager.addRule('ProgramTypesDictRoute', rules)
      }

      // Для администратора
      if (this.user('isAdmin')) {
        PermissionPageManager.addRule('AdminUsersListRoute', rules)
        PermissionPageManager.addRule('ActivityRoute', rules)
        PermissionPageManager.addRule('AdminDocumentsRoute', rules)
        PermissionPageManager.addRule('ServerLogsRoute', rules)
        PermissionPageManager.addRule('SessionsRoute', rules)
        PermissionPageManager.addRule('HistoryRoute', rules)
        PermissionPageManager.addRule('BuildInfoRoute', rules)
        if (!this.user('isFakeAuth')) {
          PermissionPageManager.addRule('FakeAuthRoute', rules)
        }
      }

      // Отображать только локально
      if (isDev) {
        PermissionPageManager.addRule('ChangeRoleView', rules)
        PermissionPageManager.addRule('ChangeUserView', rules)
      }
    } else {
      // Для не авторизованных
      PermissionPageManager.addRule('AuthRoute', rules)
      PermissionPageManager.addRule('RegistrationRoute', rules)
      PermissionPageManager.addRule('LoginRoute', rules)
      PermissionPageManager.addRule('PasswordRecoveryRoute', rules)
      PermissionPageManager.addRule('InviteLinkRoute', rules)
    }

    // Для всех
    // TODO some routes
    PermissionPageManager.addRule('ErrorRoute', rules)
    return rules
  }

  private static user(getterName: string) {
    return store.getters[`user/${getterName}`]
  }
}
